import {IView} from '@/core/Types/TableConfig';
import {BaseModel} from '@/core/standard/BaseModel';
import {ReqProtocol} from '@/core/Types/IRepository';
import {IModifierModel} from '@/modules/modifiers/IModifierModel';
import {IProductModel} from '@/modules/products/IProductModel';
import {ICategoryModel} from '@/modules/categories/ICategoryModel';
import OptionService from '@/modules/modifier-options/OptionService';

export enum optionTypes {
  'option',
  'product',
  'category',
}
export type IProductOption = IProductModel & { type: number };
export type ICategoryOption = ICategoryModel & { type: number };
export interface IOptionModel {
  id?: number | string;
  name?: string;
  min_value?: number;
  max_value?: number;
  modifiers: IModifierModel[];
  image?: any;
  price?: string;
  amount?: number;
  product?: number;
  unit?: number | string;
  name_es: string;
  name_en: string;
  is_quantifiable?: number | string;
  unit_value_format?: number | string;
  ingredients?: Array<{id: number; qty: number}>;
  type?: any;
  enabled?: boolean;
  selected?: boolean;
  modifier_id?: number | null;

  [key: string]: any;
}

export interface OptionProtocol extends ReqProtocol {
  filters: {};
}

export interface IOptions<T = any> extends BaseModel<IOptionModel, OptionProtocol, typeof OptionService>, IOptionModel {
  relationModel: T;
  mapRow(row: IOptionModel & { id: string | number })
  getOptionsByDate(query);
  insertMany(data, toast?, toastConfig?);
}

export interface IOptionsView extends IView<IOptions<any>> {

}

